import { Auth } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';

export const changePassword: (
  oldPassword: string,
  newPassword: string,
) => Promise<void> = async (oldPassword, newPassword) => {
  const user = await Auth.currentAuthenticatedUser();

  await Auth.changePassword(user, oldPassword, newPassword);
};

export const changeEmail: (newEmail: string) => Promise<void> = async (
  newEmail,
) => {
  const user = await Auth.currentAuthenticatedUser();

  await Auth.updateUserAttributes(user, { email: newEmail });
};

export const verifyEmail: (code: number) => Promise<void> = async (code) => {
  await Auth.verifyCurrentUserAttributeSubmit('email', code.toString());
};

export const changePhoneNumber: (
  newPhoneNumber: string,
) => Promise<void> = async (newPhoneNumber) => {
  const user = await Auth.currentAuthenticatedUser();
  await Auth.updateUserAttributes(user, { phone_number: newPhoneNumber });
  await Auth.verifyUserAttribute(user, 'phone_number');
};

export const verifyPhoneNumber: (code: string) => Promise<void> = async (
  code,
) => {
  await Auth.verifyCurrentUserAttributeSubmit('phone_number', code);
};

export const startVerifyUserPhoneNumber: (
  user?: CognitoUser,
) => Promise<void> = async (user = undefined) => {
  const currentUser = user || (await Auth.currentAuthenticatedUser());
  await Auth.verifyUserAttribute(currentUser, 'phone_number');
};

export const isUserPhoneNumberVerified: (
  user?: CognitoUser,
) => Promise<boolean> = async (user = undefined) => {
  const workingUser = user || (await Auth.currentAuthenticatedUser());
  const phoneNumberVerified: any = await new Promise((resolve, reject) => {
    workingUser.getUserAttributes((error: any, attributes: any) => {
      const phoneNumberVerifiedAttribute = attributes?.find(
        (a: any) => a.Name === 'phone_number_verified',
      );
      if (error) {
        reject(error);
      }
      resolve(phoneNumberVerifiedAttribute);
    });
  });
  return phoneNumberVerified?.Value === 'true';
};
